/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CollectionRecommendationResults,
  CourseRecommendationResults,
  ListCollectionRecommendationsParams,
  ListCourseRecommendationsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Collection Recommendations
 */
export const listCollectionRecommendations = (
    params?: MaybeRefOrGetter<ListCollectionRecommendationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<CollectionRecommendationResults>(
      {url: `/recommendations/collections`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCollectionRecommendationsQueryKey = (params?: MaybeRefOrGetter<ListCollectionRecommendationsParams>,) => {
    return [
    'recommendations','collections', ...(params ? [params] : [])
    ] as const;
    }


export const getListCollectionRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof listCollectionRecommendations>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListCollectionRecommendationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollectionRecommendations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCollectionRecommendationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollectionRecommendations>>> = ({ signal }) => listCollectionRecommendations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCollectionRecommendations>>, TError, TData>
}

export type ListCollectionRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCollectionRecommendations>>>
export type ListCollectionRecommendationsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List of Collection Recommendations
 */

export function useListCollectionRecommendations<TData = Awaited<ReturnType<typeof listCollectionRecommendations>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListCollectionRecommendationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollectionRecommendations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCollectionRecommendationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List of Course Recommendations
 */
export const listCourseRecommendations = (
    params?: MaybeRefOrGetter<ListCourseRecommendationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<CourseRecommendationResults>(
      {url: `/recommendations/courses`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCourseRecommendationsQueryKey = (params?: MaybeRefOrGetter<ListCourseRecommendationsParams>,) => {
    return [
    'recommendations','courses', ...(params ? [params] : [])
    ] as const;
    }


export const getListCourseRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof listCourseRecommendations>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListCourseRecommendationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseRecommendations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCourseRecommendationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourseRecommendations>>> = ({ signal }) => listCourseRecommendations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCourseRecommendations>>, TError, TData>
}

export type ListCourseRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCourseRecommendations>>>
export type ListCourseRecommendationsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List of Course Recommendations
 */

export function useListCourseRecommendations<TData = Awaited<ReturnType<typeof listCourseRecommendations>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListCourseRecommendationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseRecommendations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCourseRecommendationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






